import { SegmentationIds } from 'constants/segmentation';

export default {
  [`personalized-ribbon-${SegmentationIds.Intolerance}`]:
    '<b>Bestseller</b> for allergies',
  [`personalized-ribbon-${SegmentationIds.PickyEater}`]:
    '<b>Bestseller</b> for picky eaters',
  [`personalized-ribbon-${SegmentationIds.Overweight}`]:
    '<b>Bestseller</b> for overweight',
  [`personalized-ribbon-${SegmentationIds.Digestion}`]:
    '<b>Bestseller</b> for sensitive digestion',
  [`personalized-ribbon-${SegmentationIds.SkinFur}`]:
    '<b>Bestseller</b> for skin & coat problems',
  [`personalized-ribbon-${SegmentationIds.Disease}`]:
    '<b>Bestseller</b> for dogs with weight problems',
  [`personalized-ribbon-${SegmentationIds.Welpe}`]:
    '<b>Bestseller</b> for puppies',
  [`personalized-ribbon-${SegmentationIds.DogSenior}`]:
    '<b>Bestseller</b> for seniors',
  [`personalized-ribbon-${SegmentationIds.Bulldog}`]:
    '<b>Bestseller</b> for Bulldogs',
  [`personalized-ribbon-${SegmentationIds.Chihuahua}`]:
    '<b>Bestseller</b> for Chihuahuas',
  [`personalized-ribbon-${SegmentationIds.Dachshund}`]:
    '<b>Bestseller</b> for Dachshunds',
  [`personalized-ribbon-${SegmentationIds.Havanese}`]:
    '<b>Bestseller</b> for Maltese & Havanese',
  [`personalized-ribbon-${SegmentationIds.Poodle}`]:
    '<b>Bestseller</b> for Poodles',
  [`personalized-ribbon-${SegmentationIds.Retriever}`]:
    '<b>Bestseller</b> for Retrievers',
  [`personalized-ribbon-${SegmentationIds.ShepherdDog}`]:
    '<b>Bestseller</b> for Shepherd Dogs',
  [`personalized-ribbon-${SegmentationIds.Spitz}`]:
    '<b>Bestseller</b> for Spitz',
  [`personalized-ribbon-${SegmentationIds.Terrier}`]:
    '<b>Bestseller</b> for Terriers',
  [`personalized-ribbon-${SegmentationIds.Herdingdog}`]:
    '<b>Bestseller</b> for Herding Dogs',
  [`personalized-ribbon-${SegmentationIds.CatPickyEater}`]:
    '<b>Bestseller</b> for picky eaters',
  [`personalized-ribbon-${SegmentationIds.CatDigestion}`]:
    '<b>Bestseller</b> for sensitive digestion',
  [`personalized-ribbon-${SegmentationIds.CatOverweight}`]:
    '<b>Bestseller</b> for overweight cats',
  [`personalized-ribbon-${SegmentationIds.Kitten}`]:
    '<b>Bestseller</b> for kittens (0-1 years)',
  [`personalized-ribbon-${SegmentationIds.CatSenior}`]:
    '<b>Bestseller</b> for seniors (10+ years)',
};